import React, {Component} from 'react';
import _ from 'lodash';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import renderHTML from 'react-render-html';

import QuillShiftEnter from '../../QuillShiftEnter';
import { thaiVowels } from '../../../utils/index';

const EditingFieldName = 'content';

export default class InlineEditContent extends Component {
  constructor(props){
    super(props)

    this.state = {
      editing_content: false,
      value: this.props.content
    }

    this.quillRef = null;      // Quill instance
    this.reactQuillRef = null; // ReactQuill component
    this.unprivilegedEditor = null; // ReactQuill component

    this.handleSetValue = this.handleSetValue.bind(this);
    this.onEditingContent = this.onEditingContent.bind(this);
    this.handleChange = this.handleChange.bind(this);
    
    this.attachQuillRefs = this.attachQuillRefs.bind(this);
  }

  componentDidMount() {
    if(this.state.editing_content){
      this.attachQuillRefs()
    }
  }
  
  componentDidUpdate() {
    if(this.state.editing_content){
      this.attachQuillRefs()
    }
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.loading !== nextProps.loading){
      this.setState({
        value: nextProps.content
      })
    }
  }

  attachQuillRefs() {
    if (typeof this.reactQuillRef.getEditor !== 'function') return;
    this.quillRef = this.reactQuillRef.getEditor();
    this.unprivilegedEditor = this.reactQuillRef.makeUnprivilegedEditor(this.quillRef);
  }

  handleChange(value) {
    this.setState({ value: value });
  }

  handleSetValue(){
    console.log('handleSetValue');

    const self = this;
    let text = this.quillRef.getText();

    let break_indexs = [];
    let max_top = 0;
    _.forEach(text, function(char, index){
      var bounds = self.unprivilegedEditor.getBounds(index);

      // เมื่อขึ้นบรรทัดใหม่ และไม่ใช่บรรทัดแรก
      if(bounds.top > max_top && index !== 0){
        // ตัวอักษรก่อนหน้า
        let prev_char = self.quillRef.getText(index - 1, 1);

        // เป็นตัวอักษรตัวแรกของบรรทัด และไม่เป็นสระ
        if(parseInt(bounds.right) == 15 && !thaiVowels().includes(char.charCodeAt(0))) {
          if (prev_char.charCodeAt(0) !== 10 && char.charCodeAt(0) !== 10) {
            break_indexs.push(index);
          }
        } else {
          if(prev_char.charCodeAt(0) !== 10){
            prev_char = self.quillRef.getText(index - 2, 1);
            if (prev_char.charCodeAt(0) !== 10) {
              break_indexs.push(index - 1);
            }
          }
        }
        max_top = bounds.top;
      }

    })

    _.forEach(break_indexs.reverse(), function(i){
      self.quillRef.insertText(i, "|||");
    })

    const val = self.unprivilegedEditor.getHTML();
    const { page_number } = this.props;
    this.setState({editing_content: false},
      this.props.handleChange(EditingFieldName, val, page_number)
    );
  }

  onEditingContent(){
    if (this.state.editing_content){
        this.setState({editing_content: false});
    }else{
        this.setState({editing_content: true});
    }
  }

  stripHTML(text){
    if (_.isEmpty(text)) { return }

    var regex = /(<([^>]+)>)/ig;
     return text.replace(regex, "");
  }

  render(){
    var content = this.stripHTML(this.state.value);
    return (
      <div className='row pt-3'>
        <div className='col-12'>
          <div id='blur-editor'></div> 
          {this.state.editing_content ? (
            <div id='editing_content_id'>
              <ReactQuill 
                ref={(el) => { this.reactQuillRef = el }}
                value={this.state.value.replace(/\|\|\|/gi, '')}
                onChange={this.handleChange}
                modules={QuillShiftEnter.optionsConfig} />

              <div className='mt-2'>
                <button 
                  id='submit_edit_content'
                  type='button' 
                  className='btn btn-primary'
                  onClick={this.handleSetValue}>
                  ตกลง
                </button>
              </div>
            </div>
          ) : (
            <div id='show_content_id'>
              {content ? (
                <div className='pointer editing_content' onClick={this.onEditingContent}>
                  {renderHTML(this.state.value.replace(/\|\|\|/gi, ''))}
                </div>
              ) : (
                <div className='text-danger ml-5 pointer' onClick={this.onEditingContent}>
                  <em>{this.props.suggest_text}</em>
                </div>
              )}  
            </div>
          )}
        </div>
      </div>
    )
  }
}

document.addEventListener('click', function(event){
  var editing_content_id = document.getElementById('editing_content_id');
  var show_content_id = document.getElementById('show_content_id');

  if (show_content_id){
    if (show_content_id.contains(event.target)){ return }
  }

  if (editing_content_id){
    if (!editing_content_id.contains(event.target)){
      document.getElementById('submit_edit_content').click();
    }
  }
});


// WEBPACK FOOTER //
// ./src/components/documents/elements/InlineEditContent.js